import {
  Grid,
  MenuItem,
  Tooltip,
  IconButton,
  Button,
  CircularProgress,
  TextField
} from '@mui/material'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import React, { useEffect, useState } from 'react'
import { State, Status } from '../../hooks/useFetchState'
import { useStyles } from './styles'
import { ReturnWorkOrderResponse } from './types'
import { getOrderDevolution } from './api'
import { searchFieldOptions } from './config'
import { AxiosResponse } from 'axios'
import { GenericDLL } from '../Almacen/UI/GenericDLL'
import { useTypeAsnIncome } from '../../hooks'
import { eTypeAsnIncome } from '../../enums/eTypeAsnIncome'

export interface SearchOrderProps {
  handleSearchOrders: (apiCall: Promise<AxiosResponse<any>>) => Promise<any>
  handleSelectedOT: (workOrderId: number, orderId?: number) => void
  state: State<ReturnWorkOrderResponse[]>
  handleStep: React.Dispatch<React.SetStateAction<number>>
  handleSnackbar: (msg: string | undefined, status: boolean) => void
  setIdle: () => void
  selectedTypeAsnIncome: number
  setSelectedTypeAsnIncome: React.Dispatch<React.SetStateAction<number>>
  setSelectedWarehouseId: React.Dispatch<React.SetStateAction<number>>
  setNewPreInbound: React.Dispatch<React.SetStateAction<boolean>>
  setSelectedOrderId: React.Dispatch<React.SetStateAction<number>>
}

export const SearchOrder: React.FC<SearchOrderProps> = ({
  handleSearchOrders,
  handleSelectedOT,
  state,
  handleStep,
  handleSnackbar,
  setIdle,
  selectedTypeAsnIncome,
  setSelectedTypeAsnIncome,
  setNewPreInbound,
  setSelectedOrderId,
  setSelectedWarehouseId
}) => {
  const styles = useStyles()

  const {
    getTypeAsnIncome,
    typeAsnIncomeState: { typeAsnIncome }
  } = useTypeAsnIncome()

  const [selectedSearchField, setSelectedSearchField] = useState<
    string | undefined
  >(undefined)
  const [selectedSearchValue, setSearchValue] = useState('')

  const catchError = () =>
    handleSnackbar(
      `No existen coincidencias para ${
        selectedSearchField === 'workOrderId' ? 'OT' : 'pedido'
      } ${selectedSearchValue}`,
      false
    )

  const getOrderForReturn = () => {
    setIdle()
    if (selectedSearchField !== undefined) {
      handleSearchOrders(
        getOrderDevolution(selectedSearchField, selectedSearchValue)
      )
        .then((response: ReturnWorkOrderResponse[]) => {
          if (selectedSearchField === 'workOrderId') {
            handleSelectedOT(response[0].workOrderId)
            setSelectedOrderId(response[0].orderId)
            setSelectedWarehouseId(response[0].warehouseId)
            handleStep(3)
          } else if (selectedSearchField === 'externalOrderId') {
            // si existe una sola orden de trabajo
            if (response.length === 1) {
              handleSelectedOT(response[0].workOrderId, response[0].orderId)
              setSelectedOrderId(response[0].orderId)
              setSelectedWarehouseId(response[0].warehouseId)
              handleStep(3)
            } else {
              // si existen muchas ordenes de trabajo
              handleStep(2)
            }
          }

          setNewPreInbound(true)
        })
        .catch(catchError)
    }
  }

  const handleInputChangeTypeAsnIncome = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedTypeAsnIncome(Number(event.target.value))
  }

  const handleCleanAllData = () => {
    setSelectedSearchField(undefined)
    setSelectedTypeAsnIncome(-1)
    setSearchValue('')
  }

  useEffect(() => {
    if (typeAsnIncome?.length === 0) {
      getTypeAsnIncome()
    }
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={2} md={2} style={{ textAlign: 'left' }}>
        <GenericDLL
          fullWidth
          initialValues={typeAsnIncome || []}
          onChange={handleInputChangeTypeAsnIncome}
          title='Tipo de ingreso'
          name='name'
          valueKey={'typeAsnIncomeId'}
          value={selectedTypeAsnIncome}
          variant='outlined'
          excludedOptions={[
            eTypeAsnIncome.Fulfillment,
            eTypeAsnIncome.Restocking
          ]}
        />
      </Grid>
      <Grid item xs={10} md={2}>
        <TextField
          variant='outlined'
          fullWidth
          select
          name='selectedConnector'
          label='Buscar Por'
          value={selectedSearchField}
          onChange={(event) =>
            setSelectedSearchField(event.target.value as string)
          }
        >
          {searchFieldOptions.map(({ value, name }) => (
            <MenuItem value={value}>{name}</MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={10} md={3}>
        <TextField
          name='searchValue'
          value={selectedSearchValue}
          onChange={(e) => setSearchValue(e.target.value)}
          variant='outlined'
          fullWidth
        />
      </Grid>

      <Grid item xs={10} md={3}>
        <Button
          fullWidth
          size='large'
          disabled={
            selectedSearchField === undefined ||
            selectedTypeAsnIncome === -1 ||
            selectedSearchValue === ''
          }
          variant='contained'
          color='primary'
          onClick={getOrderForReturn}
          endIcon={
            state.status === Status.Loading && <CircularProgress size='small' />
          }
        >
          Buscar
        </Button>
      </Grid>
      <Grid item xs={10} md={1}>
        <Tooltip title='Limpiar Filtros'>
          <IconButton
            className={styles.clearFilters}
            onClick={handleCleanAllData}
          >
            <RotateLeftIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  )
}
